import { render, staticRenderFns } from "./FacetsToolbar.vue?vue&type=template&id=0b28a776"
import script from "./FacetsToolbar.vue?vue&type=script&lang=js"
export * from "./FacetsToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports